import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { ListsState } from "./types";

const state: ListsState = {
  categories: [],
  mfrs: [],
  attrs: []
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
